import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FundDetails } from 'src/app/models/mutualFund';

@Component({
  selector: 'app-selected-symbol-details-pdfs',
  templateUrl: './selected-symbol-details-pdfs.component.html',
  styleUrls: ['./selected-symbol-details-pdfs.component.scss']
})
export class SelectedSymbolDetailsPdfsComponent implements OnInit {

  lang: string;
  isDarkTheme: boolean;
  @Input() fundDetails: FundDetails;

  constructor(
    public translate: TranslateService
  ) {
    this.lang = this.translate.currentLang;
    this.isDarkTheme = localStorage.getItem("darktheme") == "dark" ? true : false;
  }

  ngOnInit(): void {
  }

  getRowIndexes(length: number): number[] {
    return Array.from({ length: Math.ceil(length / 2) }, (_, i) => i * 2);
  }
}
